import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { useNavigate } from "react-router-dom";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import IdleTimerDisplay from "./../Shared/IdleTimerDisplay_V";
import LanguageButtons from "./../Shared/LanguageButtons";
import PhoneKeypad from "./../CustomerPhoneNumber/PhoneKeypad_V";
import PhoneConfirm from "./../CustomerPhoneNumber/PhoneConfirm_V";
import PhoneDisplay from "./../CustomerPhoneNumber/PhoneDisplay_V";
import BackspaceButton from "./../CustomerPhoneNumber/BackspaceButton_V";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import KioskStepper from "./../../Components/Stepper/KioskStepper_V";
import Logo from "./../../Components/Logo_V";

import { useTheme } from "@mui/material/styles";

import { socketEventsHandler } from "./Shared/socketEventHelper";

import { Capacitor } from "@capacitor/core";
import DeviceIDPlugin from "./../../../../plugin/DeviceID";

import {
  formatNumber,
  extractNumbers
} from "./../../Components/CustomerPhoneNumber/Shared/PhoneFormatHelper";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

let env = require("./../../../../env");

function displayError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.phonenumber.errors.unablefetchaccount");
    case 401:
      return translate("application.phonenumber.errors.invalidphone");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 423:
      return translate("application.errors.webaccessdisabled");
    case 503:
      return translate("application.errors.serverunavailable");
    default:
      return translate("application.errors.unknownerror");
  }
}

export default function VerticalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    //errorMessage,
    isNotMobile,
    kioskkey,
    workflowmode,
    getKioskConfiguration
  } = props;

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const {
    isConnected,
    socketEvents,
    qrCode,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    getKioskTheme
  } = useContext(SocketIOContext);

  const { simplepost } = useContext(HttpContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const kioskverticalstyles_2 = useKioskVerticalStyles();

  const [phonenumber, setPhonenumber] = useState("");
  const [showconfirmdialog, setShowconfirmdialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const kiosktheme = getKioskTheme();

  useEffect(() => {
    socketEventsHandler(
      socketEvents,
      sessionID,
      setAll,
      setErrorMessage,
      setShowconfirmdialog,
      clearSocketEvents
    );

    // Dlog(
    //   "I think an event happened! (ACustomerPhoneNumber VerticalLayout)",
    //   socketEvents
    // );
    // if (socketEvents == null) {
    //   console.log(
    //     "(ACustomerPhoneNumber VerticalLayout) socketEvents is null, ignoring"
    //   );
    //   return;
    // }

    // let socketdata = socketEvents.data;
    // Dlog("socketdata", socketdata);

    // let action = socketdata.action;

    // switch (action) {
    //   case "REQUESTCUSTOMERINFO_RESULT":
    //     console.log("Got customer Info", socketdata.data);

    //     if (socketdata.result == "SUCCESS") {
    //       var customerFirstName = socketdata.data.firstName;
    //       var customerLastName = socketdata.data.lastName;
    //       var customerID = socketdata.data.uniqueID;

    //       setAll(
    //         //customerName, //customerName
    //         customerFirstName, //customerFirstName
    //         customerLastName, //customerLastName
    //         customerID, //customerID
    //         null, //numBags
    //         null, //numLabels
    //         null, //labelsList
    //         sessionID //sessionID
    //       );

    //       setErrorMessage("");
    //       setShowconfirmdialog(true);
    //     }
    //     break;
    // }
  }, [socketEvents]);

  //API Version
  const keypadDone = async () => {
    console.log("[ver] next called");

    let payload = {
      type: "REQUESTCUSTOMERINFO",
      payload: { type: "phone", value: phonenumber }
    };

    sendEvent(payload, () => {
      console.log("onEventSent");
    });

    return;
  };

  const hideConfirmDialog = async () => {
    setPhonenumber("");
    setShowconfirmdialog(false);
  };

  const displaystyleForconfirmdialog = async () => {
    Dlog("displaystyleForconfirmdialog", showconfirmdialog);

    if (showconfirmdialog) {
      return { display: "none" };
    } else {
      return { display: "block" };
    }
  };

  const backspacepress = async () => {
    let newNumber = phonenumber;

    if (newNumber.length > 0) {
      newNumber = newNumber.substring(0, newNumber.length - 1);
    }

    setPhonenumber(newNumber);
  };

  const next = async () => {
    navigate("/numbags");
  };

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <div style={kioskverticalstyles_2.flexBackground}>
        <div style={kioskverticalstyles_2.logo}>
          <center>
            <Logo />
          </center>
        </div>

        <div style={kioskverticalstyles_2.instructionDiv}>
          <div style={kioskverticalstyles_2.instructionVerticallyAlignDiv}>
            <Translate value="application.theme.telephoneWelcomeText" />
          </div>
        </div>
        <div
          style={{
            ...kioskverticalstyles_2.whiteDiv,
            ...kioskverticalstyles_2.flexcenterDiv
          }}
        >
          <div
            style={{ marginTop: "5vh", height: "7.7vh", marginBottom: "1.9vh" }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: "2.9vh"
              }}
            >
              {/* <Translate value="application.phonenumber.signinwithphone" /> */}
              <Translate value="application.theme.telephoneEnterNumberText" />
            </div>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: "1.9vh"
              }}
            >
              {/* <Translate value="application.phonenumber.enterslowly" /> */}
            </div>
          </div>
          <div
            id="phonedisplay"
            style={{
              display: "flex",
              //marginTop: "10.5vh",
              width: "100%",
              justifyContent: "center"
            }}
          >
            <div
              style={{
                marginBottom: "6.1vh",
                height: "4.2vh",
                display: "flex"
              }}
            >
              <PhoneDisplay value={phonenumber} />
              <BackspaceButton
                show={!showconfirmdialog}
                onClick={backspacepress}
              />
            </div>
          </div>

          <div
            id="PhoneBlock"
            style={{ width: "100%", height: "39.8vh" }} // Used to keep the model and keypad lined up
          >
            <PhoneKeypad
              phonenumber={phonenumber}
              setPhonenumber={setPhonenumber}
              keypadDone={keypadDone}
              loading={loading}
              errorMessage={errorMessage}
              showconfirmdialog={showconfirmdialog}
            />
            <PhoneConfirm
              phonenumber={phonenumber}
              showconfirmdialog={showconfirmdialog}
              hideConfirmDialog={hideConfirmDialog}
              next={next}
            />
          </div>
        </div>
        <div style={kioskverticalstyles_2.footerDiv}>
          <KioskStepper
            activeStep={0}
            backUrl={"/language"}
            workflowmode={workflowmode}
            getKioskConfiguration={getKioskConfiguration}
          />
        </div>
      </div>
      <IdleTimerDisplay />
      <PrinterConnectionModal />
    </IdleTimerProvider>
  );
}
